<div class="listing-content-wrapper">
  <div class="sticky-container">
    <div class="navigation-wrapper">
      <div class="navigation-header" (click)="onToggleMenu()">
        <h4 [innerHtml]="boondock?.name"></h4>
        <p *ngIf="lastSaved" class="fine-print-trinidad" style="float: left">
          Last saved at {{ lastSavedTime | date: 'shortTime' }}
        </p>
        <ion-icon name="chevron-down" class="chevron-toggle" *ngIf="!showMenu"> </ion-icon>
        <ion-icon name="chevron-up" class="chevron-toggle" *ngIf="showMenu"> </ion-icon>
      </div>
      <div class="navigation-body" [className]="!showMenu ? 'hide-menu' : ''">
        <div class="divider-line"></div>
        <div
          (click)="selectNavigation('description')"
          [ngClass]="{ selected: section === 'description' }"
          class="status-block"
        >
          <div class="rift-soft-title">Name &amp; Description</div>
          <div *ngIf="!descriptionCompleted()" class="required-pill">
            <p class="paragraph">TO DO</p>
          </div>
          <curbnturf-checked *ngIf="descriptionCompleted()"></curbnturf-checked>
        </div>
        <div
          (click)="selectNavigation('overview')"
          [ngClass]="{ selected: section === 'overview' }"
          class="status-block"
        >
          <div class="rift-soft-title">Overview</div>
          <div *ngIf="!overviewCompleted()" class="required-pill">
            <p class="paragraph">TO DO</p>
          </div>
          <curbnturf-checked *ngIf="overviewCompleted()"> </curbnturf-checked>
        </div>
        <div
          (click)="selectNavigation('directions')"
          [ngClass]="{ selected: section === 'directions' }"
          class="status-block"
        >
          <div class="rift-soft-title">Directions</div>
          <div *ngIf="!directionsCompleted()" class="required-pill">
            <p class="paragraph">TO DO</p>
          </div>
          <curbnturf-checked *ngIf="directionsCompleted()"> </curbnturf-checked>
        </div>
        <div
          (click)="selectNavigation('policies')"
          [ngClass]="{ selected: section === 'policies' }"
          class="status-block"
        >
          <div class="rift-soft-title">Rules &amp; Policies</div>
          <curbnturf-checked> </curbnturf-checked>
        </div>
      </div>
      <div *ngIf="errors?.length > 0" class="alert-danger">
        <div *ngFor="let error of errors" [innerHTML]="error"></div>
      </div>
    </div>
  </div>
  <div class="accordion-all">
    <div *ngIf="boondock" class="w-form">
      <ng-container *ngIf="section === 'description'">
        <curbnturf-boondock-description [boondock]="boondock"> </curbnturf-boondock-description>
      </ng-container>

      <ng-container *ngIf="section === 'overview'">
        <curbnturf-overview [boondock]="boondock"> </curbnturf-overview>
      </ng-container>

      <ng-container *ngIf="section === 'directions'">
        <curbnturf-directions [boondock]="boondock"> </curbnturf-directions>
      </ng-container>

      <ng-container *ngIf="section === 'policies'">
        <curbnturf-policies [boondock]="boondock"> </curbnturf-policies>
      </ng-container>
    </div>
    <p *ngIf="lastSaved" class="fine-print-trinidad right-align">
      Last saved at {{ lastSaved.toJSDate() | date: 'shortTime' }}
    </p>
  </div>
</div>

<curbnturf-enable-confirmation-modal> </curbnturf-enable-confirmation-modal>

<div class="spinner-wrapper" *ngIf="spinnerOn">
  <curbnturf-spinner [show]="spinnerOn"> </curbnturf-spinner>
</div>
